import React from 'react';
import { Button as ChakraButton } from '@chakra-ui/react';

import themeStyles from '../theme/styles';

const { textStyles: themeTextStyles, form } = themeStyles;

// NOTE: These are because the ButtonStyles prop is currently broken as of Chakra >1.4
const Button = ({
  textStyle = 'button',
  buttonStyle = textStyle,
  style,
  as,
  children,
  ...props
}) => {
  const textStyles = {
    paddingLeft: 8,
    paddingRight: 8,
    w: '180px',
    h: '48px',
    textStyle: 'body',
    color: 'white',
    fontWeight: '300',
    borderRadius: 0,
    _hover: { opacity: 1, bgColor: 'richBlack' },
    ...form[buttonStyle],
    ...themeTextStyles[textStyle],
    ...style,
  };
  return (
    <ChakraButton as={as} style={textStyles} {...props}>
      {children}
    </ChakraButton>
  );
};

export default Button;
